import { IGridAction, IGridActionService } from './grid-action.interface';
import { injectable } from 'inversify';
import { Observable, Subject } from 'rxjs';

@injectable()
export class GridActionService implements IGridActionService {
    private readonly subject$ = new Subject<IGridAction>();

    next(data: IGridAction): void {
        this.subject$.next(data);
    }
    asObservable(): Observable<IGridAction> {
        return this.subject$.asObservable();
    }
}
